import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=aaa5e978&scoped=true&"
import script from "./AlbumDetail.vue?vue&type=script&lang=js&"
export * from "./AlbumDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlbumDetail.vue?vue&type=style&index=0&id=aaa5e978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5e978",
  null
  
)

export default component.exports